import { lazy } from 'react';
export var TestsPageAsync = lazy(function () { return import('./TestsPage'); });
